// src/components/common/TuteeLoader.tsx
import React from 'react';
import { styled, keyframes } from '@stitches/react'; 

// 1. Animation: Draw -> Short Pause -> Unwind
const drawAndUnwind = keyframes({
  '0%':   { strokeDashoffset: 600 },         // Start hidden
  '45%':  { strokeDashoffset: 0 },           // Finished drawing (1.8s)
  '55%':  { strokeDashoffset: 0 },           // Short Pause (0.4s)
  '100%': { strokeDashoffset: 600 },         // Unwind back to hidden (1.8s)
});

// 2. Fill: Fade In -> Short Hold -> Fade Out
const fadeFillPage = keyframes({
  '0%, 100%': { fill: 'transparent' },       
  '45%, 55%': { fill: '#ffffff' },           // White fill during short pause
});

const fadeFillShadow = keyframes({
  '0%, 100%': { fill: 'transparent' },
  '45%, 55%': { fill: 'var(--colors-slate4, #cbd5e1)' }, 
});

const LoaderSvg = styled('svg', {
  width: '100px',
  height: 'auto',
  display: 'block',
  margin: '1rem auto',
  filter: 'drop-shadow(0px 4px 6px rgba(0,0,0,0.05))',

  '& path': {
    fill: 'transparent',
    strokeDasharray: 600,
    strokeDashoffset: 600,
  },

  '& .book-face': {
    // 4s total duration
    animation: `${drawAndUnwind} 4s ease-in-out infinite, ${fadeFillPage} 4s ease-in-out infinite`,
  },

  '& .book-volume': {
    animation: `${drawAndUnwind} 4s ease-in-out infinite, ${fadeFillShadow} 4s ease-in-out infinite`,
  },
  
  '& .book-detail': {
    animation: `${drawAndUnwind} 4s ease-in-out infinite`, 
  },
});

export const TuteeLoader = () => (
  <LoaderSvg viewBox="0 0 64 54" xmlns="http://www.w3.org/2000/svg">
    <g 
      fill="none" 
      stroke="var(--colors-slate12, #1e293b)" 
      strokeWidth="1.2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    >
      {/* Path 1: Top Face */}
      <path 
        className="book-face" 
        d="M 4 14 Q 18 10 32 18 Q 46 10 60 14 L 60 34 Q 46 30 32 38 Q 18 30 4 34 Z" 
      />

      {/* Path 2: Thickness */}
      <path 
        className="book-volume" 
        d="M 4 34 L 4 42 Q 18 38 32 46 Q 46 38 60 42 L 60 34 Q 46 30 32 38 Q 18 30 4 34 Z" 
      />

      {/* Path 3: Spine & Crease */}
      <path className="book-detail" d="M 32 18 L 32 38" />
      <path className="book-volume" d="M 32 38 L 32 46" />

      {/* Text Lines */}
      <path className="book-detail" d="M 8 18 Q 18 17.5 28 20" />
      <path className="book-detail" d="M 8 23 Q 18 22.5 28 25" />
      <path className="book-detail" d="M 8 28 Q 18 27.5 28 30" />

      <path className="book-detail" d="M 36 20 Q 46 17.5 56 18" />
      <path className="book-detail" d="M 36 25 Q 46 22.5 56 23" />
      <path className="book-detail" d="M 36 30 Q 46 27.5 56 28" />
    </g>
  </LoaderSvg>
);
